import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9h8a5 5 0 1 1 5 5v7","key":"svg-0"}],["path",{"d":"M7 5l-4 4l4 4","key":"svg-1"}]]

/**
 * IconArrowRoundaboutLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctcm91bmRhYm91dC1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDloOGE1IDUgMCAxIDEgNSA1djciIC8+CiAgPHBhdGggZD0iTTcgNWwtNCA0bDQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-roundabout-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowRoundaboutLeft = createReactComponent('outline', 'arrow-roundabout-left', 'ArrowRoundaboutLeft', __iconNode);

export default IconArrowRoundaboutLeft;